const PLACEHOLDER_PATTERN = /{{\s*(\w+)\s*}}/g;
/**
 * Substitutes `{{name}}` placeholders in a label. A placeholder with no matching
 * value is left as-is, so a missing value shows up in the UI instead of quietly
 * rendering an empty string.
 */
export function formatLabel(template, values) {
    return template.replace(PLACEHOLDER_PATTERN, (placeholder, placeholderName) => placeholderName in values ? String(values[placeholderName]) : placeholder);
}
